import { Skeleton, useIsMobile } from '@ferreri/prever-component-lib';
import {
  PublicationListContainer,
  StyledScrollSection,
} from '@components/layouts/Layouts';
import { SkeletonList } from '../../components/skeletons/SkeletonList';

export const SkeletonHomePublicationFeaturedList = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <StyledScrollSection>
        <PublicationListContainer>
          <Skeleton height={343} width="100%" />
        </PublicationListContainer>
      </StyledScrollSection>
    );
  }

  return (
    <StyledScrollSection>
      <PublicationListContainer>
        <SkeletonList elements={5} height={343} width="100%" />
      </PublicationListContainer>
    </StyledScrollSection>
  );
};
